import React, {useEffect, useState} from 'react';

import {View, Text, Image, StyleSheet, TouchableOpacity} from 'react-native';
import moment from 'moment';

import useIsWideDevice from '../../hooks/useIsWideDevice';
import InfoBar from './InfoBar';

const HeroNavCard = ({
  getImage,
  fallbackImage,
  title,
  subtitle,
  onPress,
  trust,
  displayDate,
  status,
  statusText,
}) => {
  const [loadedImage, setLoadedImage] = useState();

  useEffect(() => {
    const handleImage = async () => {
      const image = await getImage();
      setLoadedImage(image);
    };
    handleImage();
  }, [getImage]);

  const date = displayDate
    ? `${moment(displayDate).format('DD MMM YYYY')}`
    : '';
  const imageSource = loadedImage ? {uri: loadedImage} : fallbackImage;
  const isTablet = useIsWideDevice();

  return (
    <TouchableOpacity onPress={onPress} activeOpacity={0.7}>
      <View style={[styles.container, !isTablet && {flexDirection: 'column'}]}>
        <Image
          source={imageSource}
          style={[styles.image, !isTablet && {flexBasis: '38%'}]}
          resizeMode="cover"
        />
        <View
          style={[
            styles.content,
            isTablet ? {paddingLeft: 35} : {justifyContent: 'flex-start'},
          ]}>
          <InfoBar
            trust={trust}
            value={date}
            status={status}
            statusText={statusText}
          />
          <Text numberOfLines={2} style={styles.title}>
            {title}
          </Text>
          <Text numberOfLines={2} style={styles.subtitle}>
            {subtitle}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: '#F8F8F8',
    borderRadius: 5,
    overflow: 'hidden',
  },
  content: {
    justifyContent: 'center',
    padding: 16,
    flexShrink: 1,
  },
  title: {
    fontSize: 17,
    fontWeight: '600',
    lineHeight: 24,
    marginBottom: 8,
    flexWrap: 'wrap',
    color: '#343A40',
  },
  subtitle: {
    fontSize: 15,
    fontWeight: '400',
    lineHeight: 18,
    color: '#6D7378',
    flexWrap: 'wrap',
  },
  image: {
    flexShrink: 0,
    flexBasis: '48%',
    width: '100%',
    aspectRatio: 16 / 9,
  },
});

export default HeroNavCard;
